import { app } from "@microsoft/teams-js";

export type HostMode = "web" | "teams" | "sharepoint";
type TeamsContext = Awaited<ReturnType<typeof app.getContext>>;

export interface TeamsHostState {
  inTeams: boolean;
  context?: TeamsContext;
  error?: string;
}

export async function initializeTeamsIfNeeded(mode: HostMode): Promise<TeamsHostState> {
  const likelyTeamsFrame =
    mode === "teams" ||
    document.referrer.includes("teams.microsoft.com") ||
    document.referrer.includes("teams.cloud.microsoft") ||
    window.navigator.userAgent.includes("Teams");

  if (!likelyTeamsFrame) {
    return { inTeams: false };
  }

  try {
    await withTimeout(app.initialize(), 1600);
    const context = await app.getContext();
    app.notifySuccess();
    return { inTeams: true, context };
  } catch (error) {
    return {
      inTeams: false,
      error: error instanceof Error ? error.message : "Teams SDK did not initialize."
    };
  }
}

function withTimeout<T>(promise: Promise<T>, timeoutMs: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => reject(new Error("Teams SDK initialization timed out.")), timeoutMs);
    promise
      .then((value) => {
        window.clearTimeout(timeout);
        resolve(value);
      })
      .catch((error) => {
        window.clearTimeout(timeout);
        reject(error);
      });
  });
}
